import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
    LocationStrategy,
    HashLocationStrategy
} from '@angular/common';

import { AppComponent } from './app.component';
import { Ng2BootstrapModule } from 'ng2-bootstrap';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { AsideToggleDirective } from './shared/aside.directive';


import { HttpModule } from '@angular/http';

import { ReactiveFormsModule } from '@angular/forms';





// Routing Module
import { AppRoutingModule } from './app.routing';

//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { ClientesLayoutComponent } from './layouts/clientes-layout.component';

import { LoginComponent } from './login/login.component';
import { ClientesComponent } from './clientes/clientes.component';
import { UsuariosComponent } from './usuarios/usuarios.component';



import { TinymceEditorDirective } from './shared/tiny.directive';

//TagInputModule
import { TagInputModule } from './shared/tag-input-control/tag-input.module';

// Equal Validator
import { EqualValidator } from './shared/equal-validator.directive';

//Services
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/guards/auth-guard';
import { AuthGuardClientes } from './services/guards/auth-guard.clientes';
import { IsLoggedIn } from './services/guards/is-logged-in';
import { UsuarioService } from './services/usuario.service';
import { ClienteService } from './services/cliente.service';
import { ParametroService } from './services/parametro.service';
import { EnvioService } from './services/envio.service';
import { HttpClient } from './shared/http-client';

// Components
import { ImportarArchivosComponent } from './clientes/importar-archivos/importar-archivos.component';
import { HistoricaComponent } from './clientes/historica/historica.component';
import { AplicadaComponent } from './clientes/aplicada/aplicada.component';
import { EditarClienteComponent } from './clientes/editar/editar-cliente.component';
import { NuevoUsuarioComponent } from './usuarios/nuevo-usuario/nuevo-usuario.component';
import { EditarUsuarioComponent } from './usuarios/editar-usuario/editar-usuario.component';
import { ParametrosComponent } from './parametros/parametros.component';
import { EnviosComponent } from './envios/envios.component';
import { RegistroUsuarioComponent } from './usuarios/registro-usuario/registro-usuario.component';
import { OlvidePasswordComponent } from './usuarios/olvide-password/olvide-password.component';
import { NuevoPasswordComponent } from './usuarios/nuevo-password/nuevo-password.component';

import { BaseModule } from './shared.module';



//Algoritmo
import { AuthGuardIntranet, AuthGuardIntranetAdmin } from './intranet/services/auth-guard.intranet';
import { KairosComponent } from './intranet/kairos/kairos.component';
import { AltaKairosComponent } from './intranet/kairos/alta-kairos/alta-kairos.component';
import { KairosService } from './intranet/services/kairos.service';



@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        Ng2BootstrapModule.forRoot(), 
        ChartsModule,
        HttpModule,
        ReactiveFormsModule,
        TagInputModule,                       
        BaseModule,
            
    ],
    declarations: [
        AppComponent,
        FullLayoutComponent,
        ClientesLayoutComponent,
        NAV_DROPDOWN_DIRECTIVES,        
        SIDEBAR_TOGGLE_DIRECTIVES,
        AsideToggleDirective,
        LoginComponent,
        ClientesComponent,
        UsuariosComponent,        
        EqualValidator,        
        ImportarArchivosComponent,        
        HistoricaComponent,
        AplicadaComponent,
        EditarClienteComponent,
        NuevoUsuarioComponent,
        EditarUsuarioComponent,
        ParametrosComponent,
        TinymceEditorDirective,
        EnviosComponent,
        RegistroUsuarioComponent,
        OlvidePasswordComponent,
        NuevoPasswordComponent, 
        
        //Algoritmo
        KairosComponent, AltaKairosComponent
        //fin Algoritmo
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: LOCALE_ID, useValue: "es-AR" },        
        
        AuthGuard, AuthGuardClientes, IsLoggedIn, HttpClient, 
        AuthService, UsuarioService, ClienteService, ParametroService, EnvioService, 
        //Algoritmo
        KairosService, AuthGuardIntranetAdmin, AuthGuardIntranet
        //fin Algoritmo
        
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/app.module.ts